export const blockIconsDeviceNightlight = (
	<span className='material-symbols-outlined'>nightlight</span>
);
